<template>
<div>
         <div
              v-for="(f,index) in files"
              :key="index"
            >
              <FileUpload
                @fileSelected="initialFileSelected"
                @fileRemoved="initialFileRemoved"
                :unique-key="`${randomeGroupId}_${index}`"
                :fileName="f.name"
              />
            </div>
</div>
</template>
<script>
import FileUpload from "./FileUpload.vue";
export default {
  name: "FileUploadGrid",
  props: ["value"],
  components: { FileUpload },
  data() {
    return {
      files: [{ name: "" }],
      randomeGroupId:""
    };
  },
  mounted(){
    this.randomeGroupId=(
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
      ).toUpperCase();
  },
  methods: {
    initialFileSelected(file) {
      this.files.splice(this.files.length - 1, 0, file);
      this.listFiles = this.files.slice(0, this.files.length - 1);
      this.$emit("input", this.listFiles);
    },
    initialFileRemoved(filename, callback) {
      let index = this.files.findIndex((s) => s.name === filename);
      this.files.splice(index, 1);
      this.listFiles = this.files.slice(0, this.files.length - 1);
      callback();
      this.$emit("input", this.listFiles);
    }
  },
};
</script>
